import React from 'react';

import { FormProps } from './types';

/**
 * Note: Chakra UI does not provide a Form component.
 * Consider whether to keep this implementation or use a Form component from a library such as React Hook Form or Formik.
 */
export const Form = ({ children, ...allOtherProps }: FormProps) => {
  return <form {...allOtherProps}>{children}</form>;
};
